import en from './locales/en.json';
import de from './locales/de.json';

export const contactsLocales = {
  en: { contacts: en },
  de: { contacts: de },
};

export * from './components';
